/**
 * @generated SignedSource<<2c6952a4169f008c4975ac19bfed860c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EcommerceSettingsInput = {
  accessKey?: string | null;
  accessSecret?: string | null;
  adminPath?: string | null;
  apiKey?: string | null;
  apiSecret?: string | null;
  currencyGlobalID?: string | null;
  ecommerceGlobalID: string;
  productsApi?: string | null;
  recaptchaToken: string;
  remoteUrl?: string | null;
  salesChannelID?: string | null;
  siteId?: string | null;
};
export type apiIntegrationSalesChannelDialogInsertIntegrationMutation$variables = {
  input: EcommerceSettingsInput;
};
export type apiIntegrationSalesChannelDialogInsertIntegrationMutation$data = {
  readonly saveEcommerceSettings: {
    readonly ecommerceID: number;
  } | null;
};
export type apiIntegrationSalesChannelDialogInsertIntegrationMutation = {
  response: apiIntegrationSalesChannelDialogInsertIntegrationMutation$data;
  variables: apiIntegrationSalesChannelDialogInsertIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "settingsInput",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceID",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "apiIntegrationSalesChannelDialogInsertIntegrationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EcommerceSettings",
        "kind": "LinkedField",
        "name": "saveEcommerceSettings",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "apiIntegrationSalesChannelDialogInsertIntegrationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EcommerceSettings",
        "kind": "LinkedField",
        "name": "saveEcommerceSettings",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "10ea0e24c8fac0f32d64368ae200e7c1",
    "id": null,
    "metadata": {},
    "name": "apiIntegrationSalesChannelDialogInsertIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation apiIntegrationSalesChannelDialogInsertIntegrationMutation(\n  $input: EcommerceSettingsInput!\n) {\n  saveEcommerceSettings(settingsInput: $input) {\n    ecommerceID\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "62870e9c88d603fe6243146e6e6edc82";

export default node;
